import type { JSX } from 'react'
import { Route, Routes } from 'react-router-dom'
import AuthPage from '../Auth'
import BanishmentsPage from '../BanishmentsPage/BanishmentsPage'
import BrowseCreditApplicationsPage from '../BrowseCreditApplicationsPage'
import CreditTaskDashboardPage from '../CreditTaskDashboardPage'
import CreateCreditApplicationPage from '../EditCreditApplicationPage/CreateCreditApplicationPage'
import FeaturesSwitchForm from '../FeatureSwitch/FeaturesSwitchForm'
import Home from '../Home/HomePage'
import LoginPage from '../Home/LoginPage'
import ChatDashboardPage from '../ChatDashboardPage'
import ChatPage from '../ChatPage'
import ChatMessageManagementPage from '../ChatMessageManagement'
import AgentLogReportPage from '../Reports/AgentLogReportPage'
import PayoutThatSkippedIncomeValidation from '../Reports/PayoutThatSkippedIncomeValidation'
import Reports from '../Reports/Reports'
import ManageTestCase from '../TestCaseManagement/ManageTestCasePage'
import BulkDocumentExportPage from '../BulkDocumentExportPage'
import NewTreeSimulationPage from '../TreeSimulationsPage/NewTreeSimulationPage'
import TreeSimulationsListPage from '../TreeSimulationsPage/TreeSimulationsListPage'
import LoadCreditApplication from './LoadCreditApplication'
import NotFoundPage from './NotFoundPage'
import RequireAuth from './RequireAuth'
import RouteGuard from './RouteGuard'

const TopLevelRoutes = (): JSX.Element => {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="login" element={<LoginPage />} />
      <Route path="auth-page" element={<AuthPage />} />

      {/* Protected routes - require authentication */}
      <Route element={<RequireAuth />}>
        <Route path="/" element={<Home />} />
        <Route path="home" element={<Home />} />
        <Route path="creditTasksDashboard" element={<CreditTaskDashboardPage />} />
        <Route path="applications">
          <Route path="browse" element={<BrowseCreditApplicationsPage />} />
          <Route element={<RouteGuard requiredPermission="canEditCreditApp" />}>
            <Route path=":financingProgramId/add" element={<CreateCreditApplicationPage />} />
          </Route>
          <Route path=":financingProgramId/:id/*" element={<LoadCreditApplication />} />
        </Route>
        <Route path="reports">
          <Route path="payoutThatSkippedIncomeValidation" element={<PayoutThatSkippedIncomeValidation />} />
          <Route path="agentLog" element={<AgentLogReportPage />} />
          <Route element={<RouteGuard requiredPermission="canDownloadDocuments" />}>
            <Route path="bulk-document-export" element={<BulkDocumentExportPage />} />
          </Route>
          <Route path="" element={<Reports />} />
        </Route>
        <Route path="financial-engineer">
          <Route element={<RouteGuard requiredPermission="canRunTreeSimulation" />}>
            <Route path="tree-simulations" element={<TreeSimulationsListPage />} />
            <Route path="tree-simulations/new" element={<NewTreeSimulationPage />} />
          </Route>
        </Route>
        <Route path="banishments" element={<BanishmentsPage />} />
        <Route path="chat-dashboard" element={<ChatDashboardPage />} />
        <Route path="chat-dashboard/:financingProgramId/:creditApplicationId" element={<ChatPage />} />
        <Route path="chat-messages" element={<ChatMessageManagementPage />} />
        <Route path="featureSwitch" element={<FeaturesSwitchForm />} />
        <Route path="manageTestCases" element={<ManageTestCase />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}

export default TopLevelRoutes
